module.exports = __webpack_public_path__ + "img/BI_5.7271137b.png";